import { render, staticRenderFns } from "./HttpApiTemplate.vue?vue&type=template&id=31bb6637&"
import script from "./HttpApiTemplate.vue?vue&type=script&lang=js&"
export * from "./HttpApiTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports